export * as auth from './auth';

/* eslint-disable no-irregular-whitespace */
export const NAME_LENGTH = 30;
export const EMAIL_LENGTH = 100;
export const WEBSITE_LENGTH = 200;
export const BILLING_NOTE_LENGTH = 500;

// Regex Patterns
export const DATE_PATTERN = /^(\d{4}|\d{2})-\d{2}-(\d{4}|\d{2})+$/;
// Rails URI::MailTo::EMAIL_REGEXP
export const EMAIL_PATTERN =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

// Generated with https://mothereff.in/regexpu for ES5 compatibility
// original(1): /^[ぁ-ゞa-zA-Zａ-ｚＡ-Ｚ0-9０-９\-ー 　]+$/u
// original(2): /^[ぁ-ゞァ-ヴヵヶｦ-ﾟa-zA-Zａ-ｚＡ-Ｚ0-9０-９\-ー・ 　]+$/u
// original(3): /^([々〇〻\u3400-\u9FFF\uF900-\uFAFF]|[\uD840-\uD87F][\uDC00-\uDFFF])+$/u
export const KANA_PATTERN =
  /^[ \x2D0-9A-Za-z\u3000\u3041-\u309E\u30FC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A]+$/;

export const KANA_KANJI_PATTERN =
  /^([\u3005\u3007\u303B\u3400-\u9FFF\uF900-\uFAFF]|[\uD840-\uD87F][\uDC00-\uDFFF]|[ \x2D0-9A-Za-z\u3000\u3041-\u309E\u30A1-\u30F6\u30FB\u30FC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF9F])+$/;

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 64;
export const PASSWORD_PATTERN =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!-/:-@[-`{-~]{8,64}$/;

export const PHONE_NUMBER_PATTERN = /^[0-9\d]+[0-9\d\-ー]*[0-9\d]+$/;

export const ZIP_CODE_PATTERN =
  /^([0-9\da-zA-Zａ-ｚＡ-Ｚ]{2,5})([-ー 　]?)([0-9\da-zA-Zａ-ｚＡ-Ｚ]{2,5})$/;

// Term Spans
export const INTERVAL_BUSINESS_DAYS = 1;
export const REMOTEST_MONTHS = 6;
export const MAX_SUBSCRIPTION_USER = 500;
export const BUSINESS_DAYS_LATERS = {
  // 0(日)〜6(土)
  0: 2,
  1: 2,
  2: 2,
  3: 2,
  4: 2,
  5: 4,
  6: 3,
} as const;

// See https://github.com/globis-org/glopla-dev-portal/issues/37#issuecomment-414891943
export const SUBSCRIPTION_REQUEST_TIME_OUT = 60 * 10 * 1000;

export const SERVICE_GROUP_ID = {
  hodai: 1,
  emba: 2,
  hodaiplus: 3,
  gls: 4,
  school: 5,
  gmap: 6,
  gu: 7,
  newhodaiplus: 9,
  newemba: 10,
};

export const INVALID_ACCESS_TOKEN_ERROR = 'invalid_access_token';
export const NAME_ID_FORMAT_ERROR = 'name_id_format';
export const REAUTHENTICATION_EXPIRED_ERROR = 'reauthentication_expired';
export const INVALID_TOKEN_REVOKED = 'invalid_token.revoked';
export const ADMIN_ALREADY_DELETED_ERROR = 'admin_already_deleted';

export const FLASH_MESSAGE_LIFETIME_MILLISEC = 3000;

export const FROM_PATH_KEY = 'from-path';
